import http, {makeSearchParams} from 'utils/http';

import {API_VU_URL} from 'configs';

const httpVu = (method = 'GET', url, data, options = {}) =>
  http(method, url, data, {...options, baseURL: API_VU_URL});

/**
 * @param data
 * @returns [*]
 */
export const getCountries = (data) => {
  return httpVu('GET', 'g/countries', data);
};

/**
 * To get company detail using companyId.
 * Activation page is using this to get company detail.
 *
 * @param companyId
 * @returns {*}
 */
export const getCompanyById = (companyId) => {
  return httpVu('GET', `g/company/${companyId}`);
};

/**
 *
 * @param params
 * @returns {*}
 */
export const getSchemes = (params) => {
  return httpVu('GET', `g/schemes`, makeSearchParams(params));
};

// Unused
// export const getSchemesSectors = (params) => {
//   return http('GET', `cb-scheme-list`, makeSearchParams(params));
// };

/***
 * To get company detail using entityId.
 *
 * @param entityId
 * @returns {*}
 */
export const getRedirectById = (entityId) => {
  return http('GET', `rd/${entityId}`);
};

export const getAppById = (appId) => {
  return httpVu('GET', `g/app/${appId}`);
};

export const getCSV = (type) => {
  return http('GET', `csv/${type}`);
};

export const syncQualityTrade = ({app_id, consent}) => {
  return http('POST', `qt/sync`, {
    app_id: app_id,
    consent: consent,
  });
};

export const getLandingStats = () => {
  return httpVu('GET', `g/landing/stats`);
};

export const getLandingCountryStats = () => {
  return httpVu('GET', `g/landing/country-stats`);
};

export const getCountriesCountsABCB = (queries) => {
  return httpVu('GET', `g/countries/counts/ab-cb`, queries);
};

/**
 * Get CB list by CE ID
 * @param ceId
 * @param queries
 * @returns {*}
 */
export const getPublicCECBs = (ceId, queries) => {
  return httpVu('GET', `g/ce/${ceId}/cb`, queries);
};

export const getPublicAccountOccupations = () => {
  return httpVu('GET', '/g/account-occupations');
};

export const getPublicIndustries = () => {
  return httpVu('GET', '/g/industries');
};
